import { __rest, __read, __assign } from '../node_modules/tslib/tslib.es6.esm.js';
import React__default, { useState } from 'react';
import { Dropdown } from '@restart/ui';
import DropdownItem from './DropdownItem/DropdownItem.esm.js';
import DropdownItemsList from './DropdownItemsList/DropdownItemsList.esm.js';
import DropdownMenu from './DropdownMenu/DropdownMenu.esm.js';
import DropdownToggle from './DropdownToggle/DropdownToggle.esm.js';

var NvContextualMenu = function (_a) {
    var children = _a.children, onToggle = _a.onToggle, _b = _a.placement, placement = _b === void 0 ? 'bottom-end' : _b, defaultShow = _a.defaultShow, customShow = _a.customShow, rest = __rest(_a, ["children", "onToggle", "placement", "defaultShow", "customShow"]);
    var _c = __read(useState(defaultShow), 2), show = _c[0], setShow = _c[1];
    var handleToggle = function (nextShow) {
        setShow(nextShow);
        onToggle === null || onToggle === void 0 ? void 0 : onToggle(nextShow);
    };
    return (React__default.createElement(Dropdown, __assign({ defaultShow: defaultShow, onToggle: handleToggle, placement: placement, show: customShow !== null && customShow !== void 0 ? customShow : show }, rest),
        React__default.createElement(React__default.Fragment, null, children)));
};
var NvContextualMenu$1 = Object.assign(NvContextualMenu, {
    Item: DropdownItem,
    ItemsList: DropdownItemsList,
    Menu: DropdownMenu,
    Toggle: DropdownToggle,
});

export { NvContextualMenu$1 as default };
//# sourceMappingURL=NvContextualMenu.esm.js.map
